import { render, staticRenderFns } from "./WelcomeGloboSection.vue?vue&type=template&id=18c46f9e"
import script from "./WelcomeGloboSection.vue?vue&type=script&lang=ts"
export * from "./WelcomeGloboSection.vue?vue&type=script&lang=ts"
import style0 from "./WelcomeGloboSection.vue?vue&type=style&index=0&id=18c46f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports